import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import MaterialIcon from "./material.icon";

const commonSteps = [
    {
        content: (
            <div>
                {/* <h4>Let's begin our journey!</h4> */}
                <h4>Let's begin our tutorial!</h4>
            </div>
        ),
        placement: "center",
        target: "body"
    },
    {
        target: ".displayChatbox",
        content: "Click icon to toggle between dark and light mode",
        spotlightClicks: true
    },
    {
        target: ".drp-user i",
        content: (
            <div>
                <List
                    component="nav"
                    aria-label="Click Setting here to :"
                    subheader={
                        <ListSubheader component="div" id="nested-list-subheader">
                            CLICK SETTING TO:
                        </ListSubheader>
                    }
                >
                    <ListItem>
                        <ListItemIcon>
                            <MaterialIcon.AccessibleIcon />
                        </ListItemIcon>
                        <ListItemText primary="Toggle ON/OFF tutorial" />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <MaterialIcon.LockIcon />
                        </ListItemIcon>
                        <ListItemText primary="Change password" />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <MaterialIcon.ExitToAppIcon />
                        </ListItemIcon>
                        <ListItemText primary="Logout user" />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <MaterialIcon.VerifiedUserIcon />
                        </ListItemIcon>
                        <ListItemText primary="Set security question" />
                    </ListItem>
                </List>
            </div>
        ),
        placement: "auto"
    }
];

const tableSteps = [
    {
        target: ".pagination",
        content: "Click to move to the next page on table"
    },
    {
        target: "#add",
        content: "Click here to add new record",
        placement: "top"
    },
    {
        target: "table tbody tr",
        content: "Click on selected row to update record"
    },
    {
        target: ".tour-search",
        content: "Type here to search table record(s)"
    }
];

const tourSteps = {
    dashboardRide: [
        ...commonSteps
        // {
        //     target: '.navbar-wrapper .navbar-content ul',
        //     content: 'Click menu link to navigate',
        //     spotlightClicks:true,
        //     disableOverlayClose:true
        // },
    ],
    // roleRide,paymentCategoryRide
    commonRide: [...commonSteps, ...tableSteps],
    createUserRide: [
        ...commonSteps,
        {
            target: '.breadcrumb-item a[href="/cpay/users"]',
            content: "Click here to go back to list of users",
            placement: "auto",
            spotlightClicks: true
        },
        {
            target: ".card",
            content: "Fill form and click submit",
            placement: "auto"
        }
    ],
    editUserRide: [
        ...commonSteps,
        {
            target: '.breadcrumb-item a[href="/cpay/users"]',
            content: "Click here to go back to list of users",
            placement: "auto",
            spotlightClicks: true
        },
        {
            target: ".card",
            content: "Edit form and click submit",
            placement: "auto"
        }
    ],
    //supercorporate
    cardManagementRide: [],
    feeManagementRide: [],
    commissionAccountRide: [],
    vatAccountRide: [],
    thirdPartyRide: [],
    // corporate
    bulkUploadRide: [
        ...commonSteps,
        {
            target: ".bulk-upload-details li.tour-csv a",
            content: "Click here to download sample CSV file"
        },
        {
            target: ".bulk-upload-details li.tour-bank-code a",
            content: "Click here to download list of Bank codes"
        },
        {
            target: ".basic-multi-select.css-2b097c-container",
            content: "click here to select payment category"
        },
        {
            target: 'input[type="file"]',
            content: "click here to select csv file "
        },
        {
            target: 'button[type="submit"]',
            content: "click submit to upload file"
        },
        {
            target: "table tbody tr",
            content: "Click on selected row to go to page to initiate payment"
        }
    ],
    bulkPaymentRide: [
        ...commonSteps,
        {
            target: 'input[name="paymentDescription"]',
            content: "Type payment description here"
        },
        {
            target: "basic-multi-select.css-2b097c-container",
            content: "Select a payment approval route",
            placement: "auto"
        },
        {
            target: 'button[type="submit"]',
            content: "click submit to initiate payment"
        },
        {
            target: "table tbody tr",
            content: "Click on selected row to pop out more details"
        }
    ],
    paymentStatusRide: [
        {
            content: (
                <div>
                    {/* <h4>Let's begin our journey!</h4> */}
                    <h4>List of payments</h4>
                </div>
            ),
            placement: "center",
            target: "body"
        },
        {
            target: "table tbody tr",
            content: "Click on any selected row"
        }
    ],
    paymentProcessRide: [
        ...commonSteps,
        {
            target: ".tour-beneficiary-table table tbody tr button",
            content: "Click here to view all fees"
        }
    ]
};

export default tourSteps;
